import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../shared/models/api-response.interface';
import {
  CreateFileBody,
  MediaFile,
} from 'src/app/shared/models/media-file.model';

@Injectable({
  providedIn: 'root',
})
export class FilesApiService {
  private entityUrl: string = '/files';

  constructor(private apiService: HttpService) {}

  delete(id: number): Observable<ApiResponse> {
    return this.apiService.deleteReq(`${this.entityUrl}/${id}`);
  }

  updateFileName(
    id: number,
    file_name: string,
    description?: string
  ): Observable<ApiResponse> {
    return this.apiService.putReq(`${this.entityUrl}/${id}/update-file-name`, {
      file_name,
      description,
    });
  }

  createFile(body: CreateFileBody): Observable<ApiResponse> {
    const formData = new FormData();

    Object.entries(body).forEach(([key, value]) => {
      if (!value) {
        return;
      }

      if (value.name) {
        formData.append(key, value, value.name);
      } else {
        formData.append(key, value);
      }
    });

    return this.apiService.postReq(`${this.entityUrl}`, formData);
  }

  getFiles(model: string, id: number): Observable<ApiResponse<MediaFile[]>> {
    return this.apiService.postReq(`${this.entityUrl}/list`, {
      model,
      model_id: id,
    });
  }

  getFilesPaginated(
    model: string,
    id: number,
    length?: number,
    page?: number,
    sort: string = 'id_desc',
    isCustom: 0 | 1 = 1,
    is_agent_media: boolean = false
  ): Observable<ApiResponse<MediaFile[]>> {
    const payload: Record<string, string | number | boolean> = {
      model,
      model_id: id,
      paginate: length ?? 5,
      page: page ?? 1,
      is_custom: isCustom,
      is_agent_media,
    };

    if (sort) {
      payload['sort'] = sort;
    }
    return this.apiService.postReq(`${this.entityUrl}/paginate`, payload);
  }
}
